import * as React from "react"

export default function ChevronUpIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 9.023l-4.125 4.125-1.179-1.178L10 6.667l5.303 5.303-1.178 1.178L10 9.023z"
        fill={props.fill}
      />
    </svg>
  )
}